<template>
  <panel-layout
    id="updates-panel"
    :loading="!!(updates && updates.loading) || false"
    :heading="$t('general.updates')"
    :show-footer="false"
  >
    <div class="h-full flex flex-col">
      <o-scroll class="h-10 flex-grow p-5">
        <div v-if="updates.loading" class="absolute inset-0 h-full w-full bg-white/50 p-6 flex items-center justify-center">
          <o-loader class="h-8 w-8" />
        </div>
        <p v-if="updates.total === 0" class="p-4 text-sm text-gray-600">
          {{ $t('pages.update.index.none') }}
        </p>
        <template v-else>
          <div
            v-for="update in updates.items"
            :key="update.idNewsItem"
            class="p-3 rounded-lg shadow border mb-3 flex items-start justify-between"
          >
            <div class="flex items-start mr-8">
              <div class="h-8 w-8 flex items-center justify-center rounded-lg bg-blue-100 text-blue-500 mr-3">
                <o-icon v-if="update.isUpdateTypeNews" icon="news" />
                <o-icon v-else-if="update.isUpdateTypeAppUpdate" icon="update" />
                <o-icon v-else-if="update.isUpdateTypeNewFeature" icon="feature" />
                <o-icon v-else-if="update.isUpdateTypeNewIntegration" icon="integration" />
                <o-icon v-else-if="update.isUpdateTypeArticle" icon="blog" />
                <o-icon v-else-if="update.isUpdateTypeReleaseNotes" icon="changelog" />
                <o-icon v-else icon="update" />
              </div>
              <div class="w-full">
                <div class="flex items-center justify-between w-full">
                  <p class="focus:outline-none  text-gray-800 font-medium mb-1 leading-normal">
                    {{ update.subject }}
                  </p>
                </div>
                <p class="focus:outline-none text-sm text-gray-700 mb-4">
                  {{ update.displayDateLabel }}
                </p>

                <a class="font-medium text-blue-700 text-sm" :href="publicUpdateUrl(update)" target="_blank">
                  {{ $t('general.readMore') }}
                </a>
              </div>
            </div>

            <div class="flex-shrink-0">
              <o-chip variant="info" size="sm" flat>
                {{ update.typeLabel }}
              </o-chip>
              <o-chip v-if="update.isUpdateStatusDraft" variant="warning" size="sm" flat>
                {{ $t('general.draft') }}
              </o-chip>

              <o-button v-if="isDev || isAdmin" @click="handleMarkAsUnread(update)">
                {{ $t('pages.update.index.markAsUnread') }}
              </o-button>
            </div>
          </div>
        </template>
      </o-scroll>

      <div>
        <o-pagination v-if="updates" v-model:pager="updates" container-class="py-3 border-t flex justify-between items-center flex-shrink-0 px-4" />
      </div>
    </div>
  </panel-layout>
</template>
<script setup lang="ts">
import { TablePager } from '@/_api/lib/pager'
// @ts-ignore
import { OPagination } from '@/components/elements'
// @ts-ignore
import PanelLayout from '@/components/panel/PanelLayout.vue'

import { usePanel } from '~/composables/usePanel'

const { $api, $notification, $config } = useNuxtApp()
const panel = usePanel()

const counts = ref<any>(null)
const updates = ref(new TablePager((page: any) => $api.update.list({ page }), 20))

const isDev = computed(() => $config.public.instance === 'dev')
const isAdmin = computed(() => (panel as any)?.active?.info?.adminUser)

const publicUpdateUrl = (update: any) => {
  const section = update.isUpdateTypeReleaseNotes ? 'changelog' : 'updates'
  return `https://ovatu.com/au/${section}/${update.slug}`
}

onMounted(() => {
  fetchUpdates()
  fetchCounts()
})

async function fetchUpdates () {
  try {
    await updates.value.load()
  } catch (e: any) {
    console.log(e)
    $notification.error({ errors: e?.errors })
  }
}

async function fetchCounts () {
  try {
    const response = await $api.update.counts()

    if (response) {
      counts.value = response
    }
  } catch (e) {
    console.log(e)
  }
}

async function handleMarkAsUnread (update: any) {
  try {
    const time = update.created - 1
    const success = await $api.update.markUnread(time)
  } catch (e) {
    console.log(e)
  }
}
</script>
